import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Router } from '@angular/router';
import { ScoreModel } from 'src/app/models/score.model';
import { ScoreService } from 'src/app/services/score.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';


import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-score',
    templateUrl: './score.component.html',
    styleUrls: ['./score.component.scss'],
    imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, PageHeaderComponent, EmptyStateComponent]
})
export class ScoreComponent {
  private readonly scoreSvc = inject(ScoreService);
  private readonly _liveAnnouncer = inject(LiveAnnouncer);
  imageSvc = inject(ImageService);
  private readonly paginatorService = inject(CommonFunctionsConfiguratorService);
  private readonly router = inject(Router);


  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource = new MatTableDataSource<ScoreModel>();
  contractorsScore: ScoreModel[] = [];
  displayedColumns: string[] = [];

  ngOnInit() {
    this.scoreSvc.getContractorsScore().subscribe((data) => {
      this.contractorsScore = this.sortAndAddRanking(data);
      this.dataSource = new MatTableDataSource(this.contractorsScore);
      this.displayedColumns = [
        'ranking',
        'points',
        'fullName',
        ...this.getScoreColumnNames(),
      ];
      this.paginatorService.configurePaginator(
        this.dataSource,
        this.paginator,
        this.sort,
        "Prestadores"
      );
    });
  }

  sortAndAddRanking(scoresArray: ScoreModel[]): ScoreModel[] {
    scoresArray.sort((a, b) => b.points - a.points);

    scoresArray.forEach((score, index) => {
      score.ranking = index + 1;
    });

    return scoresArray;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  getScoreColumnNames(): string[] {
    if (this.contractorsScore.length > 0) {
      return this.contractorsScore[0].scores.map((score) => score.factorName);
    } else {
      return [];
    }
  }

  // Búsqueda de los puntajes de los elementos score dynamicos de la tabla
  getScoreValue(element: ScoreModel, factorName: string): number {
    const score = element.scores.find(
      (score) => score.factorName === factorName
    );
    return score ? score.points : 0; // Si el factor no está presente, devolvemos 0 como valor por defecto
  }

  goScoreDetail(id: string) {
    this.router.navigate(['contractor-scores/supplier-score'], { queryParams: { id } });
  }

  configurePaginator() {
    const dutchRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length == 0 || pageSize == 0) {
        return `0 de ${length}`;
      }

      length = Math.max(length, 0);

      const startIndex = page * pageSize;

      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };

    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel = '';
    this.paginator._intl.firstPageLabel = 'Primera página';
    this.paginator._intl.lastPageLabel = 'Última página';
    this.paginator._intl.nextPageLabel = 'Siguiente página';
    this.paginator._intl.previousPageLabel = 'Página anterior';
    this.paginator._intl.getRangeLabel = dutchRangeLabel;
    this.dataSource.paginator = this.paginator;
  }
}
